export default __webpack_public_path__ + "static/g1-316462e9d3ad0d6b1a297546ef9c7555.png";